<!--  -->
<!-- =========================================== -->
<script lang="ts">// ROUTER
import { Router } from "sv-router";
import "./ts/routes";
// import "./ts/test";
import "./ts/hello";
import NAV_TAB_COMPONENT from "./svelte/components/nav_tab.svelte";
import FOOTER_COMPONENT from "./svelte/components/footer.svelte";
</script>

<!--  -->
<!-- =========================================== -->
<!--  -->

<main>
  <NAV_TAB_COMPONENT />
  <Router />
  <FOOTER_COMPONENT />
</main>
